/**
 * PREMIUM CINEMATIC SLIDESHOW EFFECTS
 * Electronics Expo - High-End Aesthetic
 */

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPremiumEffects);
  } else {
    initPremiumEffects();
  }

  function initPremiumEffects() {
    const slideshows = document.querySelectorAll('.alo_slidershow[data-tech-effects="true"]');
    
    slideshows.forEach(slideshow => {
      setupPremiumContainer(slideshow);
      setupLightSweep(slideshow);
      setupPremiumParticles(slideshow);
      setupPremiumCorners(slideshow);
      waitForSlickAndSetupTransition(slideshow);
    });
  }

  /**
   * Add premium container class
   */
  function setupPremiumContainer(slideshow) {
    const wrapper = slideshow.querySelector('.wrapper-slidershow');
    if (wrapper) {
      wrapper.classList.add('tech-grid-container');
    }
  }

  /**
   * Add ambient light sweep
   */
  function setupLightSweep(slideshow) {
    const wrapper = slideshow.querySelector('.wrapper-slidershow');
    if (!wrapper || wrapper.querySelector('.premium-light-sweep')) return;

    const lightSweep = document.createElement('div');
    lightSweep.className = 'premium-light-sweep';
    wrapper.appendChild(lightSweep);
  }

  /**
   * Wait for Slick to initialize, then hook into its events
   */
  function waitForSlickAndSetupTransition(slideshow) {
    const slider = slideshow.querySelector('.js_carousel');
    if (!slider) return;

    const transitionEl = createTransitionElements(slideshow);
    if (!transitionEl) return;

    if (slider.classList.contains('slick-initialized')) {
      hookIntoSlick(slider, transitionEl);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (slider.classList.contains('slick-initialized')) {
            observer.disconnect();
            hookIntoSlick(slider, transitionEl);
          }
        }
      });
    });

    observer.observe(slider, { attributes: true });

    setTimeout(() => {
      if (slider.classList.contains('slick-initialized')) {
        observer.disconnect();
        hookIntoSlick(slider, transitionEl);
      }
    }, 3000);
  }

  /**
   * Hook into Slick's beforeChange event
   */
  function hookIntoSlick(slider, transitionEl) {
    if (typeof jQuery !== 'undefined') {
      const $slider = jQuery(slider);
      $slider.off('beforeChange.premiumEffect');
      $slider.on('beforeChange.premiumEffect', function(event, slick, currentSlide, nextSlide) {
        triggerTransition(transitionEl);
      });
    } else {
      observeSlideChanges(slider, transitionEl);
    }
  }

  /**
   * Create premium transition elements
   */
  function createTransitionElements(slideshow) {
    const wrapper = slideshow.querySelector('.wrapper-slidershow');
    if (!wrapper) return null;

    if (wrapper.querySelector('.glitch-transition')) {
      return wrapper.querySelector('.glitch-transition');
    }

    const transition = document.createElement('div');
    transition.className = 'glitch-transition';

    // Light flare wipe
    const lightFlare = document.createElement('div');
    lightFlare.className = 'light-flare';
    transition.appendChild(lightFlare);

    // Blur flash
    const blurFlash = document.createElement('div');
    blurFlash.className = 'blur-flash';
    transition.appendChild(blurFlash);

    // Scale pulse
    const scalePulse = document.createElement('div');
    scalePulse.className = 'scale-pulse';
    transition.appendChild(scalePulse);

    // Edge highlight
    const edgeHighlight = document.createElement('div');
    edgeHighlight.className = 'edge-highlight';
    transition.appendChild(edgeHighlight);

    wrapper.appendChild(transition);
    return transition;
  }

  /**
   * Trigger the premium transition
   */
  function triggerTransition(element) {
    if (!element) return;
    
    element.classList.remove('active');
    void element.offsetWidth; // Force reflow
    element.classList.add('active');
    
    setTimeout(() => {
      element.classList.remove('active');
    }, 900);
  }

  /**
   * Fallback observer
   */
  function observeSlideChanges(slider, transitionEl) {
    let currentActive = slider.querySelector('.slick-current');
    
    const observer = new MutationObserver(() => {
      const newActive = slider.querySelector('.slick-current');
      if (newActive && newActive !== currentActive) {
        currentActive = newActive;
        triggerTransition(transitionEl);
      }
    });

    observer.observe(slider, { 
      childList: true, 
      subtree: true, 
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /**
   * Floating light particles
   */
  function setupPremiumParticles(slideshow) {
    const wrapper = slideshow.querySelector('.wrapper-slidershow');
    if (!wrapper || wrapper.querySelector('.premium-particles')) return;

    const container = document.createElement('div');
    container.className = 'premium-particles';
    
    for (let i = 0; i < 8; i++) {
      const particle = document.createElement('div');
      particle.className = 'premium-particle';
      container.appendChild(particle);
    }
    
    wrapper.appendChild(container);
  }

  /**
   * Corner accents
   */
  function setupPremiumCorners(slideshow) {
    const wrapper = slideshow.querySelector('.wrapper-slidershow');
    if (!wrapper || wrapper.querySelector('.premium-corners')) return;

    const corners = document.createElement('div');
    corners.className = 'premium-corners';
    
    ['tl', 'tr', 'bl', 'br'].forEach(pos => {
      const corner = document.createElement('div');
      corner.className = `premium-corner premium-corner--${pos}`;
      corners.appendChild(corner);
    });
    
    wrapper.appendChild(corners);
  }

  // Global API
  window.TechEffects = {
    init: initPremiumEffects,
    testTransition: function() {
      const el = document.querySelector('.glitch-transition');
      if (el) {
        triggerTransition(el);
        console.log('Premium transition triggered');
      } else {
        console.log('No transition element found');
      }
    }
  };

})();
